import InfoBarMessagePart from './InfoBarMessagePart';
import {
    MessagePart,
    InfoBarMessageColor,
    InfoBarMessageViewState,
} from '../schema/InfoBarMessageViewState';
import getInfoBarIcon from '../utils/getInfoBarIcon';
import getInfoBarIconColor from '../utils/getInfoBarIconColor';
import { default as isLocalizedInfoBarMessage } from '../utils/isLocalizedInfoBarMessage';
import { observer } from 'mobx-react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { generateDomPropertiesForAria } from 'owa-accessibility';
import { logUsage } from 'owa-analytics';
import { formatToArray } from 'owa-localize';
import * as React from 'react';

const styles = require('./InfoBarMessage.scss');
const classNames = require('classnames/bind').bind(styles);

@observer
export default class InfoBarMessage extends React.Component<InfoBarMessageViewState, any> {
    render() {
        const { rank, color, textColor, ariaProps } = this.props;

        const textColorStyle = {
            red: textColor == InfoBarMessageColor.Red,
            green: textColor == InfoBarMessageColor.Green,
            yellow: textColor == InfoBarMessageColor.Yellow,
            orange: textColor == InfoBarMessageColor.Orange,
            green20: textColor == InfoBarMessageColor.Green20,
        };
        const infoBarIconColor = getInfoBarIconColor(rank, color);
        const iconName = getInfoBarIcon(rank);
        const textContainerStyle = classNames(
            styles.textContainer,
            styles.textContainerMarginForNewInfoBarUI,
            this.props.textContainerClassName,
            textColorStyle
        );

        return (
            <div
                className={classNames(styles.container, styles.newInfoBarUI)}
                {...generateDomPropertiesForAria(ariaProps)}>
                <Icon iconName={iconName} className={classNames(styles.icon, infoBarIconColor)} />
                <div className={textContainerStyle}>{this.renderContent(this.props)}</div>
            </div>
        );
    }

    private renderContent(viewState: InfoBarMessageViewState): JSX.Element {
        return (
            <>
                {viewState.messageElement
                    ? React.cloneElement(viewState.messageElement, {
                          colorScheme: viewState.colorScheme,
                      })
                    : isLocalizedInfoBarMessage(viewState)
                    ? this.renderLocalizedMessage(viewState)
                    : this.renderMessageParts(viewState.messageParts)}
            </>
        );
    }

    private renderLocalizedMessage(viewState: InfoBarMessageViewState): JSX.Element {
        return (
            <>
                {formatToArray(
                    viewState.message,
                    ...this.renderMessageParts(viewState.messageParts)
                )}
            </>
        );
    }

    private renderMessageParts(parts: MessagePart[]): JSX.Element[] {
        return parts.map((part, index) => {
            return this.renderMessagePart(part, index);
        });
    }

    private renderMessagePart(part: MessagePart, index: number): JSX.Element {
        if (part) {
            return (
                <span key={index}>
                    <InfoBarMessagePart
                        messagePart={part}
                        colorScheme={this.props.colorScheme}
                        isMessageSemibold={this.props.isMessageSemibold}
                    />
                    {index != this.props.messageParts.length - 1 ? ' ' : null}
                </span>
            );
        } else {
            // log empty case datapoint to figure out which message id has this issue and return null
            logUsage('InfoBarMessagePartEmptyCase', [this.props.key]);
            return null;
        }
    }
}
